// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"235":"capture","240":"scan"}[chunkId] + "." + {"235":"3c6fcba3","240":"4b1a54eb"}[chunkId] + ".chunk.css";
};